import * as React from 'react';
import { BaseModalLayoutProps } from '../BaseModalLayout';

export interface FullScreenModalLayoutProps extends Pick<
  BaseModalLayoutProps,
  'dataHook' | 'className' | 'style'
> {
  /** Renders modal content */
  children?: React.ReactNode;
}

export type FullScreenModalLayoutHeaderProps = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook?: string;
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   **/
  className?: string;
  /** The main content node (e.g. title) */
  children: React.ReactNode;
  /** The left node (in LTR) */
  startNode?: React.ReactNode;
  /** The right node (in LTR) */
  endNode?: React.ReactNode;
};

export type FullScreenModalLayoutContentProps = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook?: string;
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   */
  className?: string;
  /** Content node */
  children: React.ReactNode;
  /**
   * If true, applies padding to the content
   * @default false
   **/
  padding?: boolean;
};

export type FullScreenModalLayoutFooterProps = {
  /** Applies a data-hook HTML attribute that can be used in tests. */
  dataHook?: string;
  /**
   * Allows you to apply a CSS class to the component's root element.
   * @internal
   */
  className?: string;
  /** Footer node */
  children: React.ReactNode;
};
